import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { LocationState } from './types';
import { Module } from 'vuex';
import { RootState } from '../types';

export const location: Module<LocationState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
